import { render } from "./DinamicLink.vue?vue&type=template&id=55a72a6e&scoped=true"
import script from "./DinamicLink.vue?vue&type=script&lang=js"
export * from "./DinamicLink.vue?vue&type=script&lang=js"

import "./DinamicLink.vue?vue&type=style&index=0&id=55a72a6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a72a6e"]])

export default __exports__